import { Checkbox, FormControlLabel } from "@material-ui/core";
import { FormikProps } from "formik";
import React from "react";

interface ITypedProps<T> extends FormikProps<T> {
    disabled?: boolean;
    propName: keyof T;
    label: string;
    values: any;
    handleBlur: {
        (e: React.FocusEvent<any>): void;
        <T = string | any>(fieldOrEvent: T): T extends string ? (e: any) => void : void;
    };
    handleChange: {
        (e: React.ChangeEvent<any>): void;
        <T = string | React.ChangeEvent<any>>(field: T): T extends React.ChangeEvent<any> ? void : (e: string | React.ChangeEvent<any>) => void;
    };
    valueGetter?: () => any;
    onChange?: (handler: any) => (e: any) => void;
}

export const TypedFormCbxField = <T extends unknown>(props: ITypedProps<T>) => {
    return (
        <FormCbxField {...props} propName={props.propName as string} />
    );
};

interface IProps extends FormikProps<any> {
    disabled?: boolean;
    propName: string;
    label: string;
    values: any;
    handleBlur: {
        (e: React.FocusEvent<any>): void;
        <T = string | any>(fieldOrEvent: T): T extends string ? (e: any) => void : void;
    };
    handleChange: {
        (e: React.ChangeEvent<any>): void;
        <T = string | React.ChangeEvent<any>>(field: T): T extends React.ChangeEvent<any> ? void : (e: string | React.ChangeEvent<any>) => void;
    };
    valueGetter?: () => any;
    onChange?: (handler: any) => (e: any) => void;
}

class FormCbxField extends React.Component<IProps> {

    render(): JSX.Element {
        const { disabled, propName, label, values, handleChange, handleBlur, valueGetter, onChange } = this.props;

        const changeImpl = onChange ? onChange(handleChange) : handleChange;

        return (
            <FormControlLabel
                control={
                    <Checkbox color="primary"
                        id={propName}
                        name={propName}
                        disabled={disabled}
                        checked={valueGetter ? valueGetter() : values[propName]}
                        onChange={changeImpl}
                        onBlur={handleBlur(propName)}
                    />
                }
                label={label}
            />
        );
    }
}

export default FormCbxField;
